import errorMessages from './errormessages';
import ERRORS from './errorids';

export const handledErrors = [
	ERRORS.USER_AUTHENTICATION_REQUIRED,
	ERRORS.WORKSPACE_NAME_ALREADY_EXISTS,
	ERRORS.COMPANY_NAME_ALREADY_EXISTS,
	ERRORS.USER_REACHED_THE_COMPANY_INVITATION_LIMIT
];

function getErrorMessageById(id) {
	return errorMessages[id] || errorMessages.UNHANDLED_ERROR(id);
}

export default getErrorMessageById;


// WEBPACK FOOTER //
// ./src/errors/errors.js